import React from 'react';

// Build identity, stamped by scripts/build-info.js at build time rather than
// typed into .env by hand. The point of showing it is to answer one question
// from the sofa: is the code on the server the code I built? A version that
// someone maintains manually cannot answer that, because it reads the same
// whether the bundle was rebuilt, half-uploaded or a month old.
const VERSION = import.meta.env.REACT_APP_VERSION || '0.0.0';
const COMMIT = import.meta.env.REACT_APP_BUILD_COMMIT || '';
const BUILT_AT = import.meta.env.REACT_APP_BUILT_AT || '';

// "2026-09-02T20:03:25Z" reads as a machine's idea of a date. On a footer it
// only has to be short enough to compare at a glance.
const shortBuilt = (iso) => {
    if (!iso) return '';
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return iso;
    return d.toLocaleString(undefined, {
        year: 'numeric', month: 'short', day: 'numeric',
        hour: '2-digit', minute: '2-digit',
    });
};

const Footer = () => {
    // A trailing + means the bundle was built from a working tree with
    // uncommitted changes, so the commit alone does not describe it.
    const dirty = COMMIT.endsWith('+');
    const buildLabel = [VERSION && `v${VERSION}`, COMMIT].filter(Boolean).join(' · ');
    const buildTitle = [
        `Version ${VERSION}`,
        COMMIT && `Commit ${COMMIT.replace('+', '')}${dirty ? ' (with uncommitted changes)' : ''}`,
        BUILT_AT && `Built ${shortBuilt(BUILT_AT)}`,
    ].filter(Boolean).join('\n');

    return (
        <footer className="app-footer">
            <div className="app-footer__inner">
                <span className="app-footer__brand">
                    &copy; {new Date().getFullYear()}{' '}
                    <a href="https://eworx.ca" rel="noreferrer" target="_blank">eWorx Tech</a>
                    <span className="app-footer__sep" aria-hidden="true">·</span>
                    PrayerBox by <a href="https://wikimosque.com" rel="noreferrer" target="_blank">WIKIMosque</a>
                </span>

                <nav className="app-footer__links" aria-label="Footer">
                    <a href="https://wikimosque.com/privacy-policy">Privacy</a>
                    <a href="https://wikimosque.com/contact">Contact</a>
                    <a href="https://support.eworx.ca">Support</a>
                    <span
                        className={`app-footer__build${dirty ? ' app-footer__build--dirty' : ''}`}
                        title={buildTitle}>
                        {buildLabel}
                    </span>
                </nav>
            </div>
        </footer>
    );
};

export default Footer;
